/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField, Select, Autocomplete } from 'irmlib/components/FormControls'
import PropTypes from 'prop-types'
import { YDivider } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'
import { setBusy, clearBusy } from 'irmlib/containers'
import * as constants from '../../../irmlib/src/common/constants.js'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions.js'
import {
  Label,
  OutlinedButton,
  ContainedButton,
  // IconButton,
} from 'irmlib/components/Controls'
// import { LockOutlined, LockOpenOutlined } from '../../../irmlib/src/icons'
import { InputFileUploadButton } from './UploadButton.jsx'
import { storage } from '../../../utils/firestore.js'
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from 'firebase/storage'
import {
  // populateSlashOnDate,
  // dateValidatePattern,
  errorToast,
} from '../../../common/functions.js'
import { Grid } from '@material-ui/core'
// import { placeholder } from 'i18n-js'
import { LockableFields } from './LocalLockableFields.jsx'
import { createFilterOptions } from '@mui/material/Autocomplete'
import { GroupedMenu } from './GroupedMenu.jsx'
import { getUser } from '../../../redux/global.js'
// import { uploadRefImg } from '../../../services/nats/localNatsTransactions'
import { useNats } from '../../../providers/NatsProvider.jsx'
const filter = createFilterOptions()

const SELECT_DISTRICT = 0
const SELECT_BUILDING = 1
const SELECT_ORDER_NUMBER = 2
const SELECT_CUSTOM_REQUEST_NAME = 3
const SELECT_REMARKS = 4
// const SELECT_LOCKABLE_FIELD = 5
// const SELECT_LOCKED_FIELD_VALUE = 6
const SELECT_CUSTOMER_ENGMNT = 7
const SELECT_CUSTOMER_ENGMNT_LIST = 8
// const SELECT_WORKFLOW = 9
const SELECT_QC_BYPASS_THRESHOLD = 10
const getService = async (setState) => {
  const getObject = {}
  return Promise.resolve(getObject)
}

const initialSate = {
  selectedImage: false,
  selectedImageGsPath: false,
  selectedLockedField: false,
  lockedFieldValues: [],
  lockedTemplateFields: [],
  currentLockedFieldValue: false,
  displayLockedFields: '',
}

export const LocalAddActivityModal = (props) => {
  const [, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const { workerId } = getUser()
  // const snackBar = useSnackbar()
  const refLocalBusyCursor = useRef(null)
  const {
    handleShowModal,
    handleSaveActivity,
    defaultDistrict,
    buildingsList,
    postObject,
    templateFields,
    districts,
    customerId,
    customerEngmnt,
    defaultCountry,
    newWorkflow,
    QCThreshold,
  } = props
  const [buildings, setBuildings] = React.useState(null)
  const [cstmerEngmnts, setCstmerEngmnts] = React.useState([])
  const [listEnable, setListEnable] = React.useState(true)
  const [open, setOpen] = React.useState(props.showModal)
  const [selectedWorkflow, setSelectedWorkflow] = React.useState('')
  const { natsService } = useNats()
  // const useStyles = makeStyles((theme) => ({
  //   container: {
  //     padding: theme.spacing(1),
  //     borderRadius: 8,
  //     width: 'fit-content',
  //     margin: '1rem',
  //     border: '1px solid #c9c9c9',
  //     fontSize: '0.875rem',
  //     display: 'flex',
  //     justifyContent: 'space-between',
  //   },
  //   content: {
  //     fontSize: '0.875rem',
  //     lineHeight: 2.5,
  //   },
  //   value: {
  //     color: '#58595b',
  //   },
  // }))

  // const classes = useStyles()

  // const templateFieldsToLock = Object.keys(templateFields).map((key) => {
  //   return {
  //     label: key,
  //     value: key,
  //   }
  // })

  const formTemplate = [
    {
      label: 'templates.district',
      fieldKey: 'districtId',
      defaultValue: constants.defaultSelect,
      isRequired: true,
    },
    {
      label: 'templates.building',
      fieldKey: 'buildingId',
      defaultValue: constants.defaultSelect,
      isRequired: true,
    },
    {
      label: 'templates.orderNumberRequired',
      fieldKey: 'orderNumber',
      isRequired: true,
    },
    {
      label: 'templates.customRequestName',
      fieldKey: 'customRequestName',
      // defaultValue: '',
      isRequired: true
    },
    {
      label: 'templates.remarks',
      fieldKey: 'remarks',
      isRequired: false,
    },
    {
      label: 'smartCatalog.lockableField',
      fieldKey: 'lockableField',
      isRequired: false,
    },
    {
      label: '',
      fieldKey: 'lockableField',
      isRequired: false,
    },
    {
      label: 'templates.customerEngment',
      fieldKey: 'customerEngment',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.customerEngmentList',
      fieldKey: 'customerEngmentList',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.workflow',
      fieldKey: 'workflow',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.QCBypassThreshold',
      fieldKey: 'QCBypass',
      defaultValue: QCThreshold,
      isRequired: true
    }
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const VerticalDivider = () => <YDivider height='20px' />

  const handleClose = () => {
    setOpen(false)
    handleShowModal(false)
  }

  const onChangeDistrict = async (value) => {
    let buildings = []
    setBusy()
    if (value && value !== constants.defaultSelect) {
      buildings = await getBuildings(value)
    }
    clearBusy()
    return buildings
  }
  const onChangeCustomerEngmnt = async (value) => {
    let cstmerEngmnts = []
    if (value === 'BAU') return cstmerEngmnts
    setBusy()
    if (value && value !== constants.defaultSelect) {
      cstmerEngmnts = await getCstmerEngmnts(value)
    }
    clearBusy()
    return cstmerEngmnts
  }

  const getBuildings = async (district) => {
    let buildings = []
    if (district && district !== constants.defaultSelect) {
      const buildingsSnapshot = await localGdeTransactions.getBuildingForDistrict(
        district
      )
      buildings = Object.entries(buildingsSnapshot)?.map(([key, value]) => ({
        value: key,
        label: value,
      }))
      setState({ buildings: buildings })
    }
    return buildings
  }
  const isDistrictExist = (distList) => {
    return distList.includes(defaultDistrict)
  }
  const getCstmerEngmnts = async (cstmrEngmnt) => {
    const cstmrEngmntList = []
    if (cstmrEngmnt && cstmrEngmnt !== constants.defaultSelectForCE) {
      const cstmrEngmntSnapshot = await localGdeTransactions.getCstmrList(defaultCountry, cstmrEngmnt)
      // eslint-disable-next-line
      let isRestTrue = 0
      // eslint-disable-next-line
      let isRestFalse = 0
      cstmrEngmntSnapshot.docs.forEach((doc) => {
        if (doc.data().isDistrictRestricted === false) {
          isRestTrue += 1
          cstmrEngmntList.push({ value: doc.data().name, label: doc.data().name })
        } else if (doc.data().isDistrictRestricted && isDistrictExist(doc.data().restrictedDistricts)) {
          cstmrEngmntList.push({ value: doc.data().name, label: doc.data().name })
          isRestFalse += 1
        }  
      })
    }
    setState({ cstmerEngmntList: cstmrEngmntList })
    return cstmrEngmntList
  }

  useEffect(() => {
    arrRefs[SELECT_DISTRICT]?.current?.setValue(defaultDistrict)
    setBuildings(buildingsList)
  }, [arrRefs[SELECT_DISTRICT]?.current?.getValue() === undefined])

  useEffect(() => {
    arrRefs[SELECT_CUSTOMER_ENGMNT]?.current?.setValue(customerEngmnt[0].value)
    setCstmerEngmnts(customerEngmnt)
  }, [arrRefs[SELECT_CUSTOMER_ENGMNT]?.current?.getValue() === undefined])

  const ManageDistrictChange = async (value) => {
    const buildings = await onChangeDistrict(value)
    setBuildings(buildings)
    arrRefs[SELECT_BUILDING]?.current?.setValue('')
  }
  const ManageCustomerEngmnt = async (value) => {
    const cstmerEngmnts = await onChangeCustomerEngmnt(value)
    setCstmerEngmnts(cstmerEngmnts)
    arrRefs[SELECT_CUSTOMER_ENGMNT_LIST]?.current?.setValue('')
    if (value === 'BAU' || value === constants.defaultSelectForCE) {
      setListEnable(false)
    } else {
      setListEnable(true)
    }
  }

  const saveActivity = async (e) => {
    if (!arrRefs[SELECT_BUILDING]?.current?.getValue()) {
      errorToast({
        message: t('smartCatalog.buildingnameRequired'),
        title: t('toast.error'),
      })
    } else if (!arrRefs[SELECT_ORDER_NUMBER]?.current?.getValue()?.trim()) {
      errorToast({
        message: t('smartCatalog.orderIdRequired'),
        title: t('toast.error'),
      })
    } else if (!arrRefs[SELECT_CUSTOM_REQUEST_NAME]?.current?.getValue()) {
      errorToast({
        message: t('smartCatalog.requestnameRequired'),
        title: t('toast.error'),
      })
    } else if (!selectedWorkflow) {
      errorToast({
        message: t('smartCatalog.workflow'),
        title: t('toast.error'),
      })
    } else if (!arrRefs[SELECT_CUSTOMER_ENGMNT]?.current?.getValue() || (arrRefs[SELECT_CUSTOMER_ENGMNT]?.current?.getValue() === constants.defaultSelectForCE)) {
      errorToast({
        message: t('smartCatalog.cstmrEngmntType'),
        title: t('toast.error'),
      })
    } else if (listEnable && (!arrRefs[SELECT_CUSTOMER_ENGMNT_LIST]?.current?.getValue() || (arrRefs[SELECT_CUSTOMER_ENGMNT_LIST]?.current?.getValue() === constants.defaultSelect))) {
      errorToast({
        message: t('smartCatalog.cstmrEngmntName'),
        title: t('toast.error'),
      })
    } else if (!arrRefs[SELECT_QC_BYPASS_THRESHOLD]?.current?.getValue()) {
      errorToast({
        message: t('smartCatalog.QCBypassThresholdError'),
        title: t('toast.error'),
      })
    } else {
      const modalData = {
        districtId: arrRefs[SELECT_DISTRICT]?.current?.getValue(),
        buildingId: arrRefs[SELECT_BUILDING]?.current?.getValue(),
        orderNumber: arrRefs[SELECT_ORDER_NUMBER]?.current?.getValue(),
        customRequestName: arrRefs[SELECT_CUSTOM_REQUEST_NAME]?.current?.getValue(),
        remarks: arrRefs[SELECT_REMARKS]?.current?.getValue(),
        selectedImage: getState().selectedImage,
        selectedImageGsPath: getState().selectedImageGsPath,
        lockedTemplateFields: getState().lockedTemplateFields,
        custEngType: arrRefs[SELECT_CUSTOMER_ENGMNT]?.current?.getValue(),
        imProjName: arrRefs[SELECT_CUSTOMER_ENGMNT_LIST]?.current?.getValue() || '',
        workflow: selectedWorkflow,
        QCBypass: arrRefs[SELECT_QC_BYPASS_THRESHOLD]?.current?.getValue(),
        ...postObject,
      }
      handleSaveActivity(modalData)
    }
  }

  const handleImageUpload = async (value) => {
    if (value) {
      setBusy()
      const imageRef = storageRef(
        storage,
        `smartCatalog/gde_refImg_${workerId}_${Date.now()}.jpg`
      )
      uploadBytes(imageRef, value)
        .then((snapshot) => {
          getDownloadURL(snapshot.ref)
            .then((url) => {
              const gspath = `gs://${snapshot.ref.bucket}/${snapshot.ref.fullPath}`
              setState({
                selectedImage: url,
                selectedImageGsPath: gspath,
              })
              clearBusy()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error.message)
              setBusy()
            })
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error.message)
          setBusy()
        })
    }
  }
  const handleImageUploadToNats = async(originalFile) => {
    if (originalFile) {
      const rename = `nats_refImg_${workerId}_${Date.now()}.jpg`
      const renamedFile = new File([originalFile], rename, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      })
      const { nuid, name } = await natsService.uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      // const { nuid, name } = await uploadRefImg(constants.LOCAL_NATS_SERVER, constants.LOCAL_AI_REF_IMG, renamedFile)
      setState({
        selectedImage: name,
        selectedImageGsPath: nuid,
      })
    } else {
      const error = getState().validationErrors
      setState({ validationErrors: { ...error, btnError: 'Incorrect format or size.' } })
    }
  }
  // const handleLockableFieldInput = async (value) => {
  //   if (value) {
  //     arrRefs[SELECT_LOCKED_FIELD_VALUE]?.current?.setValue('')
  //     setState({ currentLockedFieldValue: false })
  //     Object.keys(templateFields).map((key) => {
  //       if (value === key) {
  //         templateFields[key].fieldName = value
  //         if (
  //           getState()?.lockedFieldValues[value] !== '' &&
  //           getState()?.lockedFieldValues[value] !== undefined
  //         ) {
  //           const showValue = getState()?.lockedFieldValues[value]
  //           arrRefs[SELECT_LOCKED_FIELD_VALUE]?.current?.setValue(showValue)
  //         }

  //         setState({
  //           selectedLockedField: templateFields[key],
  //         })
  //       }
  //       return true
  //     })
  //   } else {
  //     setState({
  //       selectedLockedField: false,
  //     })
  //   }
  // }

  // const handleCustomFormats = (keyCode, value, fields) => {
  //   const format = fields?.format
  //   const isDate = Object.keys(dateValidatePattern).includes(format)
  //   if (isDate && value) {
  //     const dateValue = populateSlashOnDate(keyCode, value)
  //     if (dateValue) {
  //       return dateValue
  //     }
  //   }

  //   // else if (appConstants.countrySpecificFormats.includes(format) && value) {
  //   //   const formattedValue = formatValue(keyCode, fields?.regExPattern, value)
  //   //   return formattedValue
  //   // }
  //   return false
  // }

  // const handleKeyUp = (e, val) => {
  //   const value = handleCustomFormats(
  //     e?.keyCode,
  //     e?.target?.value,
  //     val
  //   )
  //   if (value) {
  //     e.target.value = value
  //   }
  // }

  // const handleLockedFieldValue = async (e, key) => {
  //   e.preventDefault()
  //   if (
  //     e.target.value &&
  //     e.target.value !== undefined &&
  //     e.target.value !== ''
  //   ) {
  //     setState({
  //       currentLockedFieldValue: {
  //         ...getState().currentLockedFieldValue,
  //         [key]: e.target.value
  //       },
  //     })
  //   }
  //   // } else {
  //   //   setState({ currentLockedFieldValue: false })
  //   // }
  // }

  // const saveLockableFields = (mode, key) => {
  //   const lockedFieldInfo = key
  //   if (mode === 'setValue' && getState()?.currentLockedFieldValue[key]) {
  //     setState({
  //       lockedFieldValues: {
  //         ...getState().lockedFieldValues,
  //         [lockedFieldInfo]: getState()?.currentLockedFieldValue[key],
  //       },
  //     })
  //     setTimeout(snackBar(t('toast.lockSuccess')), 50000)
  //   } else if (
  //     mode === 'resetValue' &&
  //     getState()?.lockedFieldValues[lockedFieldInfo]
  //   ) {
  //     delete getState().lockedFieldValues[lockedFieldInfo]
  //     setState({
  //       lockedFieldValues: getState().lockedFieldValues,
  //     })
  //     setTimeout(snackBar(t('toast.lockRemove')), 50000)
  //   }

  //   // arrRefs[SELECT_LOCKED_FIELD_VALUE]?.current?.setValue('')
  //   // arrRefs[SELECT_LOCKABLE_FIELD]?.current?.setValue('')
  //   // setState({ currentLockedFieldValue: false })
  // }
  
  const handleLockableFields = async(data) => {
    const lockedTemplateFields = []
    Object.keys(templateFields).forEach((key) => {
      if (data[key]) {
        const fieldData = {
          ...templateFields[key]
        }
        fieldData.isLocked = true
        fieldData.lockedValue = data[key]
        lockedTemplateFields[key] = fieldData
      }
    })


    setState({
      lockedTemplateFields: lockedTemplateFields,
    })
  }
  const onChangeWorkflowType = (value) => {
    setSelectedWorkflow(value)
  }
  customerEngmnt.forEach((element) => {
    element.label = t(`dropdowns.${element.value}`)
  })
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} sx={
        {
          '& .MuiPaper-root': { // Target the Paper component
            width: '100%',
            maxWidth: '610px', // Set your custom max width here
          },
        } }
      maxWidth='xs' 
      disableEnforceFocus>
        <DialogTitle>{t('templates.createActivity')}</DialogTitle>
        <DialogContent>
          <>
            <VerticalDivider />
            {/* <div style={{ minWidth: '350px' }}></div> */}
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Select
                  id={'createActivity_district'}
                  onChange={ManageDistrictChange}
                  data={data}
                  items={districts}
                  fieldTemplate={formTemplate[SELECT_DISTRICT]}
                  ref={arrRefs[SELECT_DISTRICT]}
                  style={{ marginBottom: '20px' }}
                  noTranslateItems
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  id={'createActivity_building'}
                  data={data}
                  options={buildings || []}
                  fieldTemplate={formTemplate[SELECT_BUILDING]}
                  ref={arrRefs[SELECT_BUILDING]}
                  style={{ marginBottom: '20px' }}
                  noTranslateItems
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id={'createActivity_orderNumber'}
                  data={data}
                  fieldTemplate={formTemplate[SELECT_ORDER_NUMBER]}
                  ref={arrRefs[SELECT_ORDER_NUMBER]}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id={'createActivity_customRequestName'}
                  data={data}
                  fieldTemplate={formTemplate[SELECT_CUSTOM_REQUEST_NAME]}
                  ref={arrRefs[SELECT_CUSTOM_REQUEST_NAME]}
                />
              </Grid>
              <Grid item xs={4}>
                <GroupedMenu
                  id={'createActivity_workflow'}
                  assetTypes={newWorkflow || {}}
                  label={t('templates.workflow')}
                  onSelect={onChangeWorkflowType}
                  size={190}
                />
              </Grid>
              <Grid item xs={4}>
                <Select
                  id={'createActivity_customerEngmnt'}
                  data={data}
                  items={props.customerEngmnt}
                  fieldTemplate={formTemplate[SELECT_CUSTOMER_ENGMNT]}
                  ref={arrRefs[SELECT_CUSTOMER_ENGMNT]}
                  onChange={ManageCustomerEngmnt}
                  noTranslateItems
                />
              </Grid>
              {listEnable
                ? <>
                  <Grid item xs={4}>
                    <Autocomplete
                      id={'createActivity_customerEngmntList'}
                      data={data}
                      options={cstmerEngmnts || []}
                      filterOptions={(options, params) => {
                        const filtered = filter(options || [], params)

                        const { inputValue } = params
                        const isExisting = (options || []).some(
                          (option) => inputValue === option.label
                        )
                        if (inputValue !== '' && !isExisting) {
                          filtered.push({
                            value: inputValue,
                            label: `"${inputValue}" Project does not exist. Click to add.`,
                          })
                        }

                        return filtered
                      }}
                      getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                          return option
                        }
                        if (option.value) {
                          return option.value
                        }
                        return option.label
                      }}
                      renderOption={(props, option) => {
                        return (
                          <li key={props.lable} >
                            {props.label}
                          </li>
                        )
                      }}
                      fieldTemplate={formTemplate[SELECT_CUSTOMER_ENGMNT_LIST]}
                      ref={arrRefs[SELECT_CUSTOMER_ENGMNT_LIST]}
                      noTranslateItems
                      freeSolo
                    />
                  </Grid>
                </>
                : null
              }
              {/* <Grid item xs={6}>
                <Select
                  id={'createActivity_workflow'}
                  data={data}
                  items={props.workflow}
                  fieldTemplate={formTemplate[SELECT_WORKFLOW]}
                  ref={arrRefs[SELECT_WORKFLOW]}
                  noTranslateItems
                />
              </Grid> */}
              <Grid item xs={4}>
                <TextField
                  id={'createActivity_QCBypassThreshold'}
                  data={data}
                  fieldTemplate={formTemplate[SELECT_QC_BYPASS_THRESHOLD]}
                  ref={arrRefs[SELECT_QC_BYPASS_THRESHOLD]}
                  inputProps={{
                    maxLength: 2,
                    onKeyPress: (e) => {
                      // Only allow digits (0-9)
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault()
                      }
                    }
                  }}
                />
              </Grid>
              
              <Grid item xs={4}>
                <TextField
                  id={'createActivity_remarks'}
                  data={data}
                  fieldTemplate={formTemplate[SELECT_REMARKS]}
                  ref={arrRefs[SELECT_REMARKS]}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              </Grid>
              <LockableFields
                templateFields={templateFields}
                templateFieldsLocked={''}
                getLockableFields={handleLockableFields}
                accountLevel1={customerId}
              />
              {/* {Object.keys(templateFields).map((key, index) => (
                <Grid container sx={{ display: 'flex' }}>
                  <Grid item xs={4}>
                   
                    <Typography variant='body1' className={classes.content}>
                      <span className={classes.value}>{key}&nbsp;:&nbsp;</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id={`createActivity_locked_field_value${index}`}
                      inputProps={{
                        readOnly: getState()?.lockedFieldValues[key] !== undefined,
                        style: { color: getState()?.lockedFieldValues[key] ? '#1975BC' : 'inherit' },
                        placeholder: templateFields[key]?.format
                      }}
                      value={getState()?.lockedFieldValues[key] ? getState()?.lockedFieldValues[key] : ''}
                      data={data}
                      fieldTemplate={formTemplate[SELECT_LOCKED_FIELD_VALUE]}
                      ref={arrRefs[SELECT_LOCKED_FIELD_VALUE]}
                      style={{ marginBottom: '20px' }}
                      onKeyDown={(e) => {
                        handleKeyUp(e, templateFields[key])
                      }}
                      // onKeyUp={(e) => handleKeyUp(e, props.element)}
                      onBlur={(e) => handleLockedFieldValue(e, key)}
                    />
                  </Grid>
                  <Grid xs={0}>
  <span className={classes.value} style={{ color: '#1975BC' }}>
    {getState()?.lockedFieldValues[key] 
      ? <>
        <IconButton
          style={{
            color: '#1a1b1c',
            margin: '-10px -35px -10px -10px',
            float: 'right',
          }}
          onClick={() => saveLockableFields('resetValue', key)}
        >
          <LockOutlined />
        </IconButton>
      </>
      : <IconButton
        style={{
          color: '#1975BC',
          margin: '-10px -35px -10px -10px',
          float: 'right',
        }}
        onClick={() => saveLockableFields('setValue', key)}
      >
        <LockOpenOutlined />
      </IconButton>
        }
  </span>
</Grid>
                </Grid>
              ))} */}
            {/* </Grid> */}
            <VerticalDivider />
            <InputFileUploadButton onImageCapture={handleImageUploadToNats} maxSize={5} allowedFormats = {['JPG', 'JPEG']} />
          </>
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <OutlinedButton
            style={{ width: '90px', height: '36.5px', margin: '5px' }}
            onClick={handleClose}
          >
            buttons.cancel
          </OutlinedButton>
          <ContainedButton
            style={{ width: '160px', height: '36.5px', margin: '5px' }}
            onClick={(e) => saveActivity(e)}
          >
            buttons.createRequest
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

LocalAddActivityModal.propTypes = {}

LocalAddActivityModal.propTypes = {
  showModal: PropTypes.bool,
  handleShowModal: PropTypes.func,
  handleSaveActivity: PropTypes.func,
  defaultDistrict: PropTypes.any,
  districts: PropTypes.any,
}

// AddActivityModal.defaultProps = {
//   getLockableFields: null,
// }
